module.exports = __webpack_public_path__ + "img/Stark_erhöhte_Aktivität.8877cced.svg";